import * as types from './mutation-types'

export default {
	[types.SET_SESSION_ID] (state, sessionId) {
		state.sessionId = sessionId
	},

	[types.SET_SUBSCRIPTION_ERROR] (state, error) {
		state.subscriptionError = error
	},

	[types.SET_SUBSCRIPTION_READY] (state, ready) {
		state.subscriptionReady = ready
	},

	[types.SET_VIN_IMPORT_EVENT] (state, event) {
		state.vinImportEvent = event
	},

	[types.SET_CREATE_FROM_DRAFT_EVENT] (state, event) {
		state.createFromDraftEvent = event
	},

	[types.SET_CREATE_FROM_DRAFT_MODAL_OPEN] (state, open) {
		state.isCreateFromDraftModalOpen = open
	}
}
